import { apiClientV1 } from './apiClient';

export default {
  getVideoStatistics: (videoId, params) => apiClientV1.get(`/video/${videoId}/breakdown`, { params }),
  removeTracking: (params) => apiClientV1.put(`/video/tracking/${params.id}/delete`, { ...params }, { silentErrorNotification: true }),
  updateRecipient: (trackingId, params) => apiClientV1.put(`/video/tracking/${trackingId}`, { ...params }),
  updateTracking: (id, params) => apiClientV1.put(`/video/tracking/${id}`, { ...params }),
  saveRecipients: (params) => apiClientV1.post('/video/tracking/recipients', { ...params }),
  restoreDeletedLink: ({ linkId, ...rest }) => apiClientV1.put(`/video/tracking/${linkId}/restore`, { ...rest }),
  // video links types:
  // [all, qr_code, prospect, yardi, entrata, integration, embed_code, social_media]
  getShareLinks: (videoId, params) => apiClientV1.post(`/video/${videoId}/links`, { ...params }),
  // playlist links types:
  // [all, qr_code, prospect, yardi, entrata, social_media]
  getPlaylistShareLinks: (playlistId, params) => apiClientV1.post(`/video/playlist/${playlistId}/links`, { ...params }),
  getVideoGenericLink: (videoId) => apiClientV1.post(`/video/${videoId}/generic-links`),
  saveSocialMediaTracking: (params) => apiClientV1.post('/video/tracking/social-media', { ...params }),
  createQrCodeTracking: (params) => apiClientV1.post('/video/tracking/qr_code', { ...params }),
  trackCopy: (trackingId, params) => apiClientV1.put(`/video/tracking/${trackingId}/copy`, { ...params }, { silentErrorNotification: true }),
  trackCopyGif: (trackingId) => apiClientV1.put(`/video/tracking/${trackingId}/copy-gif`),
  trackBrandingBtnClick: ({ id, ...params }) => apiClientV1.put(`/video/tracking/${id}/save-branding-action`, { ...params })
};
